import PasswordValidator from "password-validator";

const schema = new PasswordValidator();

schema.is().min(8)
    .is().max(50)
    .has().uppercase()
    .has().lowercase()
    .has().digits()
    .has().symbols()
    .has().not().spaces();

export const validatePassword = (value: string, t: any): Promise<any> => {
    if (!value) {
        return Promise.resolve();
    } else {
        const result = schema.validate(value, {list: true}) as any[];
        
        if (result.length === 0) {
            return Promise.resolve();
        } else {
            return Promise.reject(t('error.password.' + result[0]));
        }
    }
};

export const validateRepeatPassword = (value: string, password: string, t: any): Promise<any> => {
    if (!value && !password) {
        return Promise.resolve();
    } else {
        if (value === password) {
            return Promise.resolve();
        } else {
            return Promise.reject(t('error.password.notMatch'));
        }
    }
};

export const validateMoreThan = (value: any, value2: any, t: any): Promise<any> => {
    if (!value || !value2) {
        return Promise.resolve();
    } else {
        if (value > value2) {
            return Promise.resolve();
        } else {
            return Promise.reject(t('error.moreThan').split('${value2}').join(String(value2)));
        }
    }
};
